import { Component } from '@angular/core';
import { TextFilterField } from './filter-field-text';
import { FilterFieldComponent } from '../filter-field.component';

@Component({
  selector: 'va-filter-text',
  template: `
    <mat-form-field>
      <input
        matInput
        [placeholder]="'' + filterField.name | translate"
        [(ngModel)]="filterValue"
        (keyup.enter)="applyFilter(filterValue)"
        (blur)="applyFilter(filterValue)"
      />
    </mat-form-field>
  `,
})
export class TextFilterFieldComponent extends FilterFieldComponent<TextFilterField> {
  filterValue: string;
}
